<template>
  <div class="container">
    <br/><br/>
    <h1 class="step-title">
      <img src='@/assets/images/common/img_completed.png' alt="" />
    </h1>
    <p class="step-contents text-center">
      접수해주셔서 감사합니다.
      <br/>
      담당자가 곧 연락드리겠습니다.
    </p>
    <br/><br/>
    <div class="bottom-btn">
      <v-btn color="mainColorDark" x-large depressed block class="mb-3 btn-text-white" @click="clickHome">닫기</v-btn>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    // 컴포넌트가 마운트되면 화면 맨 위로 스크롤
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    clickHome() {
      this.$router.push({ path: '/home' }).catch(() => {});
    }
  },
};
</script>
